import { Typography } from '@mui/material';
import { Workflow, WorkflowNode } from 'api/model';
import useRevisedWorkflowsFromNodes from 'api/workflows/useRevisedWorkflowsFromNodes';
import useProjects from 'api/projects/useProjects';
import { NavigateFunction } from 'react-router';
import { ToastContentProps } from 'react-toastify';
import WorkflowCard from './WorkflowCard';

type Props = Partial<ToastContentProps> & {
  title: string;
  nodes: WorkflowNode[];
  navigate: NavigateFunction;
};

const PersistentNodesToast = (props: Props) => {
  const { title, nodes, navigate } = props;
  const { revisedWorkflowsData: workflows } = useRevisedWorkflowsFromNodes({ nodes });
  const { projects } = useProjects();
  const nodeIds = new Set(nodes.map((node) => node.id));

  const navigateToWorkflow = (workflow: Workflow) => {
    void navigate(`/projects/${workflow.project_id}/workflows/${workflow.id}/canvas`);
  };

  return (
    <div>
      <Typography className="mb-2">{title}</Typography>
      <div className="max-h-96 overflow-y-auto">
        {workflows?.map((workflow) => {
          const project = projects?.find((p) => p.id === workflow.project_id);
          return (
            <WorkflowCard
              key={workflow.id}
              workflow={workflow}
              project={project}
              nodeIds={nodeIds}
              onNavigate={navigateToWorkflow}
              selectable={false}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PersistentNodesToast;
